import React, { memo } from 'react';
import { PlanSelector } from './PlanSelector';
import { UrgencyBanner } from './UrgencyBanner';
export function FooterCta() {
  return <section className="bg-navy px-5 py-10 md:py-[70px] text-center" data-id="element-74">
      <div className="mx-auto max-w-[820px]" data-id="element-75">
        <h2 className="mb-2 font-bebas text-[clamp(32px,5vw,58px)] text-white" data-id="element-76">
          No dejes pasar
          <br data-id="element-77" />
          <span className="text-gold" data-id="element-78">esta oportunidad</span>
        </h2>
        <p className="mx-auto mb-6 md:mb-10 max-w-[560px] text-[16px] text-white/65" data-id="element-79">
          Cada semana sin protocolos es una semana con riesgo legal, pacientes
          que no vuelven y decisiones que dependen de tu memoria. Eso cambia
          hoy.
        </p>

        <UrgencyBanner data-id="element-80" />

        <PlanSelector showFeatures={false} data-id="element-81" />

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-82">
          {['✓ Pago seguro con Mercado Pago', '✓ Acceso en menos de 5 minutos', '✓ Garantía 7 días'].map((trust, i) => <span key={i} className="font-montserrat text-[12px] font-medium text-white/50" data-id="element-83">
              {trust}
            </span>)}
        </div>
      </div>
    </section>;
}